import React, { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FiMail, FiUser, FiLock, FiMap, FiArrowRight } from 'react-icons/fi';
import { Link, useParams } from 'react-router-dom';
import {
  FaWhatsapp,
  FaFileMedical,
  FaNotesMedical,
  FaHospital,
  FaSimplybuilt,
  FaBuilding,
  FaIdBadge,
  FaClinicMedical,
} from 'react-icons/fa';
import { ISigla, readSigla, siglas as siglasRef } from './siglas';
import { MdError, MdDateRange, MdChat } from 'react-icons/md';

import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormHandles } from '@unform/core';
import Input from '../../../components/Forms/Input';
import Button from '../../../components/Forms/Button';
import Loader from '../../../components/Loader';
import MaskedInput from '../../../components/Forms/MaskedInput';
import { ResponseMessage } from '../../../components/ResponseMessage';
import getValidationErrors from '../../../utils/getValidationErrors';
import { Error } from './styles';
import SelectSimple from '../../../components/Forms/SelectSimple';
import Whatsapp from '../../../components/WhatsAppCompartilhar';
import WhatsappCall from '../../../components/Whatsapp';
import api from '../../../services/api';
import { authTitle, defaultProjectHash, recaptchaKey, urlWebsite } from '../../../config';
import { countries } from './countries';
import TextareaInput from '../../../components/Forms/TextareaInput';
import { useToast } from '../../../hooks/Toast';
import CheckboxInput from '../../../components/Forms/CheckboxInput';
import getCep from '../../../services/cep';
import Axios from 'axios';
import states from './states';
import { useLanguage } from '../../../hooks/Language';
import CompleteSaleFields from './CompleteSaleFields';
import testCPF from '../../../utils/testCPF';
import { addYears, isValid } from 'date-fns';
import { useAuth } from '../../../hooks/Auth';
import QRCodeUserModule from '../../DashboardPages/core/components/lineModules/QrCodeUserModule';
import { useConfiguration } from '../../../hooks/Configuration';

interface IRecoverFormData {
  [key: string]: any;
}


interface IRead {
  [key: string]: any;
}

interface IOption {
  value: string;
  label: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
  productId: string;
}

interface ICaptcha {
  getValue(): string;
}

declare var window: any;


const escolaridade = [
  { value: "ANALFABETO", label: "ANALFABETO", text: "ANALFABETO" },
  { value: "PRIMÁRIO INCOMPLETO (ATÉ 4º)", label: "PRIMÁRIO INCOMPLETO (ATÉ 4º)", text: "PRIMÁRIO INCOMPLETO (ATÉ 4º)" },
  { value: "PRIMÁRIO COMPLETO", label: "PRIMÁRIO COMPLETO", text: "PRIMÁRIO COMPLETO" },
  { value: "ENSINO FUNDAMENTAL INCOMPLETO", label: "ENSINO FUNDAMENTAL INCOMPLETO", text: "ENSINO FUNDAMENTAL INCOMPLETO" },
  { value: "ENSINO FUNDAMENTAL COMPLETO", label: "ENSINO FUNDAMENTAL COMPLETO", text: "ENSINO FUNDAMENTAL COMPLETO" },
  { value: "ENSINO MÉDIO INCOMPLETO", label: "ENSINO MÉDIO INCOMPLETO", text: "ENSINO MÉDIO INCOMPLETO" },
  { value: "ENSINO MÉDIO COMPLETO", label: "ENSINO MÉDIO COMPLETO", text: "ENSINO MÉDIO COMPLETO" },
  { value: "ENSINO SUPERIO INCOMPLETO", label: "ENSINO SUPERIO INCOMPLETO", text: "ENSINO SUPERIO INCOMPLETO" },
  { value: "ENSINO SUPERIOR COMPLETO", label: "ENSINO SUPERIOR COMPLETO", text: "ENSINO SUPERIOR COMPLETO" },
  { value: "PÓS GRADUAÇÃO - ESPECIALIZAÇÃO", label: "PÓS GRADUAÇÃO - ESPECIALIZAÇÃO", text: "PÓS GRADUAÇÃO - ESPECIALIZAÇÃO" },
  { value: "MESTRADO", label: "MESTRADO", text: "MESTRADO" },
  { value: "DOUTORADO", label: "DOUTORADO", text: "DOUTORADO" }

]




const unimeds = [
  { value: "UNIMED ALEGRETE/RS", label: "UNIMED ALEGRETE/RS", text: "UNIMED ALEGRETE/RS" },
  { value: "UNIMED ALTO DA SERRA", label: "UNIMED ALTO DA SERRA", text: "UNIMED ALTO DA SERRA" },
  { value: "UNIMED ALTO JACUÍ/RS", label: "UNIMED ALTO JACUÍ/RS", text: "UNIMED ALTO JACUÍ/RS" },
  { value: "UNIMED ALTO URUGUAI/RS", label: "UNIMED ALTO URUGUAI/RS", text: "UNIMED ALTO URUGUAI/RS" },
  { value: "UNIMED CENTRO/RS", label: "UNIMED CENTRO/RS", text: "UNIMED CENTRO/RS" },
  { value: "UNIMED ENCOSTA DA SERRA/RS", label: "UNIMED ENCOSTA DA SERRA/RS", text: "UNIMED ENCOSTA DA SERRA/RS" },
  { value: "UNIMED ERECHIM/RS", label: "UNIMED ERECHIM/RS", text: "UNIMED ERECHIM/RS" },
  { value: "UNIMED FEDERAÇÃO/RS", label: "UNIMED FEDERAÇÃO/RS", text: "UNIMED FEDERAÇÃO/RS" },

  { value: "UNIMED FRONTEIRA NOROESTE/RS", label: "UNIMED FRONTEIRA NOROESTE/RS", text: "UNIMED FRONTEIRA NOROESTE/RS" },
  { value: "UNIMED ITAQUI/RS", label: "UNIMED ITAQUI/RS", text: "UNIMED ITAQUI/RS" },
  { value: "UNIMED LITORAL SUL/RS", label: "UNIMED LITORAL SUL/RS", text: "UNIMED LITORAL SUL/RS" },
  { value: "UNIMED MISSÕES/RS", label: "UNIMED MISSÕES/RS", text: "UNIMED MISSÕES/RS" },
  { value: "UNIMED NORDESTE - RS", label: "UNIMED NORDESTE - RS", text: "UNIMED NORDESTE - RS" },
  { value: "UNIMED NOROESTE/RS", label: "UNIMED NOROESTE/RS", text: "UNIMED NOROESTE/RS" },
  { value: "UNIMED PELOTAS/RS", label: "UNIMED PELOTAS/RS", text: "UNIMED PELOTAS/RS" },
  { value: "UNIMED PLANALTO CENTRAL/RS", label: "UNIMED PLANALTO CENTRAL/RS", text: "UNIMED PLANALTO CENTRAL/RS" },
  { value: "UNIMED PLANALTO MÉDIO/RS", label: "UNIMED PLANALTO MÉDIO/RS", text: "UNIMED PLANALTO MÉDIO/RS" },
  { value: "UNIMED PORTO ALEGRE", label: "UNIMED PORTO ALEGRE", text: "UNIMED PORTO ALEGRE" },
  { value: "UNIMED REGIÃO DA CAMPANHA/RS", label: "UNIMED REGIÃO DA CAMPANHA/RS", text: "UNIMED REGIÃO DA CAMPANHA/RS" },
  { value: "UNIMED REGIÃO DA FRONTEIRA/RS", label: "UNIMED REGIÃO DA FRONTEIRA/RS", text: "UNIMED REGIÃO DA FRONTEIRA/RS" },
  { value: "UNIMED REGIÃO DA PRODUÇÃO/RS", label: "UNIMED REGIÃO DA PRODUÇÃO/RS", text: "UNIMED REGIÃO DA PRODUÇÃO/RS" },
  { value: "UNIMED SANTA MARIA/RS", label: "UNIMED SANTA MARIA/RS", text: "UNIMED SANTA MARIA/RS" },
  { value: "UNIMED URUGUAIANA/RS", label: "UNIMED URUGUAIANA/RS", text: "UNIMED URUGUAIANA/RS" },
  { value: "UNIMED VALE DAS ANTAS, RS", label: "UNIMED VALE DAS ANTAS, RS", text: "UNIMED VALE DAS ANTAS, RS" },
  { value: "UNIMED VALE DO CAÍ/RS", label: "UNIMED VALE DO CAÍ/RS", text: "UNIMED VALE DO CAÍ/RS" },
  { value: "UNIMED VALE DO SINOS/RS", label: "UNIMED VALE DO SINOS/RS", text: "UNIMED VALE DO SINOS/RS" },
  { value: "UNIMED VALES DO TAQUARI E RIO PARDO", label: "UNIMED VALES DO TAQUARI E RIO PARDO", text: "UNIMED VALES DO TAQUARI E RIO PARDO" },
  { value: "UNIMED CENTRAL DE SERVIÇOS", label: "UNIMED CENTRAL DE SERVIÇOS", text: "UNIMED CENTRAL DE SERVIÇOS" },
  { value: "UNICOOPMED", label: "UNICOOPMED", text: "UNICOOPMED" },
  { value: "UNIAIR TRANSPORTE AEROMÉDICO", label: "UNIAIR TRANSPORTE AEROMÉDICO", text: "UNIAIR TRANSPORTE AEROMÉDICO" },
  { value: "INSTITUTO UNIMED/RS", label: "INSTITUTO UNIMED/RS", text: "INSTITUTO UNIMED/RS" },


];


const FormContainer = ({ context = {} }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<Array<string>>([]);
  const [withPassword, setWithPassword] = useState(true);
  const formRefConfirmationOK = useRef<FormHandles>(null);
  const formRefConfirmation = useRef<FormHandles>(null);
  const formRef = useRef<FormHandles>(null);
  const recaptchaRef = useRef(null);
  const { projectHash = defaultProjectHash, eventHash, productId } = useParams<IParams>();
  const [companyValue, setCompanyValue] = useState('');
  const [emailRecord, setEmailRecord] = useState('');
  const { signIn, user } = useAuth();
  const [category, setCategory] = useState('');


  const getCaptchaValue = (elem: ICaptcha): string => {
    return elem.getValue();
  };
  const siglas = readSigla();
  const { addToast } = useToast();
  const { translate } = useLanguage();
  const { configuration } = useConfiguration();
  const [countryISO, setCountryISO] = useState('BR');
  const [position, setPosition] = useState('');
  const [otherCompany, setOtherCompany] = useState('');
  const [product, setProduct] = useState<Record<string, any>>({});
  const [cities, setCities] = useState<Array<IOption>>([]);
  const [stateValue, setStateValue] = useState('');


  const [currentEmail, setCurrentEmail] = useState('');
  const [ready, setReady] = useState(false);
  const [statusConfirmation, setStatusConfirmation] = useState('new-subscriber');

  const callCityApi = async (value) => {

    const response = await Axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${value}/municipios`);

    if (response) {

      const values: Array<IOption> = [];

      response.data.map(city => {
        values.push({ value: city.nome, label: city.nome });
      })

      setCities(values);
    }


  }

  useEffect(() => {
    callCityApi(stateValue);
  }, [stateValue])



  const getCepFromApi = async (value: string): Promise<void> => {
    const cepResponse = await getCep(value);

    if (!cepResponse.error) {
      formRef?.current?.setFieldValue('address', cepResponse.logradouro);
      formRef?.current?.setFieldValue('neighborhood', cepResponse.bairro);
      formRef?.current?.setFieldValue('city', cepResponse.localidade);
      formRef?.current?.setFieldValue('state', cepResponse.uf);
    }
  };


  const handleNewLoginUpdate = async (data: IRecoverFormData) => {
    setLoading(true);
    try {
      formRef.current?.setErrors({});

      const fieldsValues: Record<string, any> = {};
      let fieldsText = '';
      const shape = {

      };

      if (product?.fields && product?.fields.length > 0) {


        const fieldsKeys: Array<string> = [];


        let x = 1;
        product?.fields.map((f: Record<string, any>) => {
          if (f.mandatory === 'yes') {
            shape[f.field] = Yup.string().required(`Campo ${translate(f.label)} é obrigatório`);
          }
          fieldsKeys.push(f.field);
          fieldsValues[f.field] = data?.[f.field];

          if (x > 1) {
            fieldsText = `${fieldsText} | `;
          }

          fieldsText = `${fieldsText}${data?.[f.field]}`;


          x++;

        })


      }


      const schema = Yup.object().shape(shape);



      await schema.validate(data, { abortEarly: false });

      const content: Record<string, any> = {
        ...data,
        email: emailRecord,
        project_id: projectHash,
        event_id: eventHash ? eventHash : '',
        product: product._id.toString(),
        fields: { ...fieldsValues },
        fields_text: fieldsText,
      };



      const newUser = await api
        .post('/signup-update', content)
        .catch(error => {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formRef.current?.setErrors(errors);
            setLoading(false);
          }

          addToast({
            type: 'error',
            title: error?.response?.data?.message || error?.response?.data?.error || 'Erro ao cadastrar',
          });
          setLoading(false);
          return false;
        });

      if (!newUser) {
        setLoading(false);
        return false;
      }

      if (window?.fbq) {
        window.fbq('track', 'CompleteRegistration');
      }

      setSuccess(true);
      setLoading(false);


      return false;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);

        const errorInfo = err.errors.reduce((error, prev) => {
          prev = `${prev}, ${error}`;
          return prev;
        });
        setLoading(false);
        addToast({
          type: 'error',
          title: 'Erro de validação',
          description: errorInfo,
        });
      }
      setLoading(false);
    }
  }

  const checkQuantity = async ({ project_id, sales_limit, sales_limit_type }) => {
    console.log(sales_limit)
    if (sales_limit_type === 'yes') {
      setLoading(true);
      const check = await api.get(`/check-sales-quantity/${project_id}`);



      if (check?.data?.count >= sales_limit) {
        setStatusConfirmation('finished');
      }
      else {

      }

      setLoading(false);
    }

  }

  useEffect(() => {


    checkQuantity({ project_id: projectHash, sales_limit: configuration?.current_event_id_response?.sales_limit, sales_limit_type: configuration?.current_event_id_response?.sales_limit_type });


  }, [projectHash])


  const handleNewLogin = async (data: IRecoverFormData) => {
    setLoading(true);

    const fieldsValues: Record<string, any> = {};
    let fieldsText = '';

    data.extra_1 = data?.extra_1?.[0] ? data?.extra_1?.[0] : '';

    if (countryISO === 'BR') {
      data.document_type = 'cpf';
    }
    if (data?.company === 'OUTRA') {
      data.company = data?.company_value || '';
    }


    try {
      formRef.current?.setErrors({});


      const shape = category === 'Médicos, Dirigentes e Colaboradores da Unimed' ? {
        category_id: Yup.string().required('Categoria de inscrição obrigatória'),
        name: Yup.string().required('Nome obrigatório'),
        email: Yup.string()
          .required('Email obrigatório')
          .email('Preencha um email válido'),

        phone: Yup.string()
          .required('Telefone com DDD é obrigatório'),
        birth_date: Yup.string().required('Campo Data de Nascimento é obrigatório'),
        company: Yup.string().required('Campo Unimed / instituição é obrigatório'),
        document_number: Yup.string().required('Campo CPF é obrigatório'),
        cpf_familiar: Yup.string().required('Campo RG é obrigatório'),
        extra_5: Yup.string().required('Campo Emissor do RG é obrigatório'),
        education_id: Yup.string().required('Campo Escolaridade é obrigatório'),
        country: Yup.string().required('Campo País é obrigatório'),
        state: Yup.string().required('Campo Estado é obrigatório'),

        know_about: Yup.string().required('Campo Como souber do evento é obrigatório'),

      } : {
        category_id: Yup.string().required('Categoria de inscrição obrigatória'),
        name: Yup.string().required('Nome obrigatório'),
        email: Yup.string()
          .required('Email obrigatório')
          .email('Preencha um email válido'),

        phone: Yup.string()
          .required('Telefone com DDD é obrigatório'),
      };




      if (product?.fields && product?.fields.length > 0) {


        const fieldsKeys: Array<string> = [];


        let x = 1;
        product?.fields.map((f: Record<string, any>) => {
          if (f.mandatory === 'yes') {
            shape[f.field] = Yup.string().required(`Campo ${translate(f.label)} é obrigatório`);
          }
          fieldsKeys.push(f.field);
          fieldsValues[f.field] = data?.[f.field];

          if (x > 1) {
            fieldsText = `${fieldsText} | `;
          }

          fieldsText = `${fieldsText}${data?.[f.field]}`;

          x++;

        })


      }


      const schema = Yup.object().shape(shape);
      data.phone = data?.phone?.toString()?.replace(/[^0-9]/g, '') || '';
      data.birth_date = data?.birth_date?.toString()?.replace(/[^0-9/]/g, '') || '';
      data.document_number = data?.document_number?.toString()?.replace(/[^0-9]/g, '') || '';












      data.email = data?.email?.trim()?.toLowerCase() || '';

      await schema.validate(data, { abortEarly: false });




      const captchaValue =
        getCaptchaValue(recaptchaRef?.current || { getValue: () => '' }) ||
        false;

      const content: Record<string, any> = {
        ...data,
        project_id: projectHash,
        event_id: eventHash ? eventHash : '',
        captcha: captchaValue,
        term: ['Aceito'],
        fields: { ...fieldsValues },
        fields_text: fieldsText
      };

      if (productId) {
        content.product = productId;
      }


      const newUser = await api
        .post('/signup', content)
        .catch(error => {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formRef.current?.setErrors(errors);
            setLoading(false);
          }

          addToast({
            type: 'error',
            title: error?.response?.data?.message || error?.response?.data?.error || 'Erro ao cadastrar',
          });
          setLoading(false);
          return false;
        });

      if (!newUser) {
        setLoading(false);
        return false;
      }

      if (window?.fbq) {
        window.fbq('track', 'CompleteRegistration');
      }

      const userInfo = signIn({ email: data?.email });

      setSuccess(true);
      setLoading(false);
      window?.scrollTo(0, 0);


      return false;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);

        const errorInfo = err.errors.reduce((error, prev) => {
          prev = `${prev}, ${error}`;
          return prev;
        });
        setLoading(false);
        addToast({
          type: 'error',
          title: 'Erro de validação',
          description: errorInfo,
        });
      }
      setLoading(false);
    }
  }

  const handleSendConfirmation = async () => {

    try {
      const confirm = await api.post(`/confirm-subscriber`, { email: currentEmail, project_id: projectHash, event_id: eventHash ? eventHash : '', product: productId ? productId : '' });

      if (confirm) {
        setSuccess(true);
        setStatusConfirmation('finished');

      }
      setLoading(false);
    }
    catch (err) {
      addToast({ type: 'error', title: 'Erro ao confirmar inscrição' });
      setLoading(false);
    }



  }

  const handleConfirmation = async (data) => {

    data.email = data?.email?.trim()?.toLowerCase() || '';

    try {
      const checkUser = await api.post(`/check-subscriber`, { email: data.email, project_id: projectHash, event_id: eventHash || '', product: productId ? productId : '' });

      if (checkUser) {
        setCurrentEmail(data.email);
        setStatusConfirmation(checkUser?.data?.status || 'new-subscriber');
        if (checkUser?.data?.product?._id) {

          setProduct(checkUser?.data?.product);
        }
        setEmailRecord(data.email)
        setReady(true);

      }

    }
    catch (err) {
      addToast({ type: 'error', title: err?.response?.data?.message || 'Erro ao checar usuário, por favor, tente novamente' });
      return
    }


  }





  if (statusConfirmation === 'finished') {

    return (
      <>

        <h1 style={{ color: '#2e4336', fontSize: '24px', marginBottom: '20px', marginTop: '20px', textAlign: 'center' }}>Inscrições encerradas</h1>

        <p style={{ color: '#2e4336', marginBottom: '10px', textAlign: 'center' }}>Agradecemos seu interesse</p>

        <Link to={`/app/${projectHash}/`} className="buttonBigBlue"><button type="button">
          Voltar
        </button></Link>
      </>
    )
  }

  if (statusConfirmation === 'confirmated') {

    return (
      <>

        <h1 style={{ color: 'rgb(0,15,64)', marginBottom: '20px' }}>Olá participante!</h1>

        <p style={{ color: 'rgb(0,15,64)', marginBottom: '20px' }}>Identificamos o seu cadastro em nossa plataforma. A sua inscrição no próximo evento está confirmada.</p>

        <Link to={`/app/${projectHash}/login`}><button className="defaultButton" type="button">
          Acessar
        </button></Link>
      </>
    )
  }



  if (statusConfirmation === 'update') {
    return <>
      {loading === true && (
        <Loader message="Validando dados..." position="fixed" />
      )}

      <aside>
        {success ? (
          <ResponseMessage
            active
            type="clean"
            title=""
            description={
              <p style={{ color: '#2e4336' }}>
                <h2 className="titleH2" style={{ color: '#2e4336', fontSize: '28px' }}> Cadastro realizado com sucesso!</h2>
                <br />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Link to={`/app/${projectHash}/login/`} >
                    <button className="defaultButton" type="button">
                      Acessar
                    </button>
                  </Link>
                </div>
                <br />
                Aproveite e indique para seus amigos!
                <Whatsapp
                  text={`Olá! Acabei de me inscrever no 11º Fórum Instituto Unimed/RS. Acredito que você irá gostar de participar desse evento! Inscreva-se pelo link: https://11-forum-unimed.encontrodigital.com.br`}
                  number=""
                  message="Compartilhe!"
                />
              </p>
            }
          />
        ) : (<>

          <Form ref={formRef} style={{ padding: '15px', minWidth: '320px' }} onSubmit={handleNewLoginUpdate} initialData={{}}>
            <h1 style={{ color: 'rgb(0,15,64)', marginBottom: '20px' }}>Completar inscrição</h1>

            {product && product?.fields && product?.fields.length > 0 ? <CompleteSaleFields fields={product.fields} /> : <></>}

            <aside style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button className="defaultButton" type="submit">
                Finalizar inscrição


              </button>
            </aside>
          </Form>
        </>
        )}
      </aside>
    </>
  }



  return (
    <>
      {loading === true && (
        <Loader message="Preparando seu cadastro..." position="fixed" />
      )}

      <aside>
        {success ? (
          <ResponseMessage
            active
            type="clean"
            title=""
            description={
              <div style={{ color: '#2e4336' }}>
                <h2 className="titleH2" style={{ color: '#2e4336', fontSize: '24px' }}> Parabéns pela inscrição! </h2>
                <br />

                <div > O <strong style={{ color: '#333', display: 'inline' }}>QRcode</strong> de acesso será enviado para<br />
                  o e-mail informado e <strong style={{ color: '#333', display: 'inline' }}>deverá<br />
                    ser apresentado no dia do evento.</strong> <br />
                </div>
                {user && user?.user_hash ? <><QRCodeUserModule content={`<p style="color: #000; padding: 15px; borderRadius: 15px; background: #fff; textAlign: left; width: 100%; maxWidth: 600px; margin: 0px auto;">
             
             Data: 15 de setembro de 2023<br />
Horário: 8h
             <br /><br />
             Estacionamento no local:<br />
              Teatro do Bourbon Country<br /><br />
              Carros: R$ 12,00 por até 3 horas, com adicional de R$ 2,00 para cada hora excedente.<br /><br />
              Motos R$ 7,00 por até 3 horas, com adicional de R$ 1,00 para cada hora excedente.<br /><br />
              Valores poderão sofrer alteração sem aviso prévio, conforme tabela do operador do local.
            </p>`} /> </> : <></>}
                <br />
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', }}><Link to="/app/11-forum-unimed/local" style={{ color: '#2e4336', fontSize: '14px' }}> Clique <u style={{ color: '#2e4336', fontSize: '14px', display: 'inline' }}>aqui</u> para informações <br />
                  sobre o estacionamento. </Link></div>


                {/*     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Link to={`/app/${projectHash}/login/`} >
                    <button className="buttonBigGreen" type="button">
                      Acessar
                    </button>
                  </Link>
                </div>
                <br />
                Aproveite e indique para seus amigos!
                <Whatsapp
                  text={`Olá! Acabei de me inscrever no 11º Fórum Instituto Unimed/RS. Acredito que você irá gostar de participar desse evento! Inscreva-se pelo link: 11-forum-unimed.encontrodigital.com.br`}
                  number=""
                  message="Compartilhe!"
            /> */}
              </div>
            }
          />
        ) : (<>

          <Form name={projectHash} ref={formRef} onSubmit={handleNewLogin} initialData={{ country: 'BR' }} style={{ marginTop: '0px' }}>
            <h3 style={{ color: 'rgb(2, 147, 142)', textAlign: 'center', marginBottom: '20px', marginTop: '0px', fontSize: '32px' }}>Inscreva-se!</h3>

            <p className='shadow' style={{ textAlign: 'left', marginBottom: '20px', color: '#2e4336', fontSize: '14px', background: '#fff', padding: '15px', borderRadius: '10px' }}>
              <strong style={{ color: '#2e4336' }}>Inscrição gratuita e com certificado. </strong><br /><br /><strong style={{ color: "rgb(2, 147, 142)" }}>Convidamos a participar da Campanha Prato Cheio - Mesa Brasil Sesc/RS, contribuindo com a doação de alimentos não perecíveis que serão arrecadados no evento.</strong>


            </p>


            <SelectSimple name="category_id" setCallback={(value) => setCategory(value)} label="Categoria de inscrição" options={[

              { label: 'Médicos, Dirigentes e Colaboradores da Unimed', value: 'Médicos, Dirigentes e Colaboradores da Unimed', text: 'Médicos, Dirigentes e Colaboradores da Unimed' },
              { label: 'Público Geral', value: 'Público Geral', text: 'Público Geral' },

            ]} />

            <Input name="name" placeholder="Nome completo" />
            <Input name="email" placeholder="E-mail" />

            {countryISO === 'BR' ? <MaskedInput
              mask="(99) 999999999"
              name="phone"
              placeholder="Telefone com DDD"
            /> : <Input name="phone" placeholder={'Telefone com DDD'} />}

            {category === 'Médicos, Dirigentes e Colaboradores da Unimed' ? <>

              <MaskedInput
                mask="999.999.999-99"
                name="document_number"
                placeholder={translate('CPF')}
              />







              <MaskedInput mask={'99/99/9999'}
                name="birth_date"
                placeholder="Data de nascimento"
              />



              <Input name="cpf_familiar"
                placeholder={translate('RG')} />

              <Input name="extra_5"
                placeholder={translate('Orgão emissor do RG')} />

              <SelectSimple name="company" setCallback={(value) => setCompanyValue(value)} label="Unimed / Instituição" options={unimeds} />

              {companyValue === "OUTRA" ?
                <Input name="company_value"
                  placeholder={translate('Qual instituição')} /> : <></>}

              <Input name="position"
                placeholder={translate('Cargo')} />
              <SelectSimple name="education_id" label="Escolaridade" options={escolaridade} />



              <SelectSimple setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={'Pais'} />

              {countryISO === 'BR' ? <SelectSimple setCallback={(value) => {
                setStateValue(value);
              }} options={states} name="state" label="Estado" /> :

                <Input name="state" placeholder={'Província / Região'} />}

            </>
              : <></>}



            <SelectSimple

              options={[
                { label: 'WhatsApp', value: 'WhatsApp' },
                { label: 'Indicação', value: 'Indicação' },
                { label: 'Instagram', value: 'Instagram' },
                { label: 'Facebook', value: 'Facebook' },
                { label: 'Linkedin', value: 'Linkedin' },
                { label: 'E-mail marketing', value: 'E-mail marketing' },
                { label: 'SMS', value: 'SMS' },
                { label: 'Workplace', value: 'Workplace' },
                { label: 'Google', value: 'Google' },
                { label: 'Outros', value: 'Outros' },



              ]}
              name="know_about"
              formRef={formRef}
              label="Como ficou sabendo do evento?"
            />



            {product && product?.fields && product?.fields.length > 0 ? <aside style={{ display: 'flex', width: '100%', justifyContent: 'center', alignContent: 'center', flexDirection: 'column', margin: '30px 0px', border: '2px 0px #ddd' }}> <h2 style={{ fontSize: '12px', color: '#333', margin: '10px 0px' }}>Dados específicos do evento</h2>  <CompleteSaleFields fields={product.fields || []} /></aside> : <> </>}


            <div style={{ marginBottom: '10px', padding: '15px', borderRadius: '10px' }}>


              <p
                style={{
                  padding: '10px',
                  background: 'none',
                  margin: '5px auto',
                  color: '#333',
                  fontSize: '12px',
                  textAlign: 'left',
                }}
              >

                Estou ciente de que estou fornecendo ao 11º Fórum Instituto Unimed/RS e seus parceiros meus contatos gerais, os quais são dados pessoais protegidos pela Lei Geral de Proteção de Dados brasileira, para gestão de relacionamento e marketing do 11º Fórum Instituto Unimed/RS, conforme Política de Privacidade disponível neste site.
                <br /><br />


                {'Ao me cadastrar, afirmo que li a'}
                {' '}
                <strong>
                  <Link
                    style={{ display: 'inline', color: '#333' }}
                    to="/termos"
                    target="_BLANK"
                  >
                    {'Política de Privacidade'}
                    {' '}
                  </Link>
                  {' '}
                </strong>
                {'desta plataforma.'}
              </p>
            </div>
            <aside style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />

            </aside>  <aside style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button className="buttonBigGreen" type="submit">
                Finalizar inscrição


              </button>


            </aside>

            <aside style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <WhatsappCall />


            </aside>
            {/*   <p style={{ color: '#2e4336', padding: '15px', borderRadius: '15px', background: '#fff', textAlign: 'left', width: '100%', maxWidth: '600px', margin: '30px auto' }}>
              Estacionamento no local:<br />
              Teatro do Bourbon Country<br /><br />
              Carros: R$ 12,00 por até 3 horas, com adicional de R$ 2,00 para cada hora excedente.<br /><br />
              Motos R$ 7,00 por até 3 horas, com adicional de R$ 1,00 para cada hora excedente.<br /><br />
              Valores poderão sofrer alteração sem aviso prévio, conforme tabela do operador do local.
              </p> */}
          </Form>


        </>
        )}
      </aside>

    </>
  );
};

export default FormContainer;
